"use client"

import { useEffect, useState } from "react"

type ToastProps = {
  title?: string
  description?: string
  variant?: "default" | "destructive"
}

export function useToast() {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return {
      toast: (props: ToastProps) => {},
      dismiss: (toastId?: string) => {},
    }
  }

  return {
    toast: ({ variant = "default", ...props }: ToastProps) => {
      // In a real implementation, this would use a toast library
      // For simplicity, we're using alert here
      if (variant === "destructive") {
        alert(`Error: ${props.title}\n${props.description}`)
      } else {
        alert(`${props.title}\n${props.description}`)
      }
      return "toast-id"
    },
    dismiss: (toastId?: string) => {},
  }
}
